import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Severity } from '../../../models/severity';
import { NgClass, NgIf } from '@angular/common';
import { HeaderComponent } from '../header/header.component';
import { DividerModule } from 'primeng/divider';
import { AlertStyleDirective } from '../../../directives/alert-style.directive';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [NgClass, HeaderComponent, NgIf, DividerModule, AlertStyleDirective],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  animations: [
    trigger('detailContentState', [
      state(
        'hidden',
        style({
          height: '0',
          overflow: 'hidden',
          opacity: 0,
        })
      ),
      state(
        'visible',
        style({
          height: '*',
          opacity: 1,
        })
      ),
      transition('hidden <=> visible', animate('300ms ease-in-out')),
    ]),
  ],
})
export class AlertComponent {
  @Input() severity: Severity = 'info';
  @Input() text?: string;
  @Input() icon?: string;
  @Input() header?: string;
  @Input() canToggle = true;
  @Input() styleClass = '';
  @Input() toggleLabel = 'Details öffnen ...';
  //@ContentChild(TemplateRef) introTextTemplate: TemplateRef<any> | null = null;
  @ViewChild('contentWrapper', { static: false }) contentWrapper!: ElementRef;

  collapsed = true;

  /**
   * Toggles the collapsed state by switching its current boolean value.
   *
   * @return {void} Does not return anything.
   */
  toggleCollapsed() {
    this.collapsed = !this.collapsed;
  }

  /**
   * Retrieves the icon class associated with the current severity level.
   * If a custom icon is set, it will return that icon; otherwise, it will
   * return a predefined icon based on the severity.
   *
   * @return {string} A string representing the FontAwesome icon class for the severity level or the custom icon, if provided.
   */
  get severityIcon(): string {
    if (this.icon) {
      return this.icon;
    }
    return {
      info: 'fas fa-info-circle',
      warning: 'fas fa-exclamation-triangle',
      error: 'fas fa-exclamation-circle',
      success: 'fas fa-check-circle',
      secondary: 'fas fa-info-circle',
      lock: 'fas fa-lock',
    }[this.severity];
  }
}
